import React, { useState } from "react";
import StepperNavButton from "../components/stepper/StepperNavButton";
import TablerLayout from "../components/layout/TablerLayout";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { useOrderSave } from "../context/OrderSaveContext";
import { IconSquare, IconSquareCheck } from "@tabler/icons-react";
import { dataService } from "../services/dataService";

const FelolvasoTabla = () => {
	const navigate = useStepNavigate();
	const { order, updateOrder } = useOrder();
	const { setModal } = useOrderSave();
	const [isRead, setIsRead] = useState(false);
	const [loading, setLoading] = useState(false);

	const partner = order.partner || {};
	const hmeliorder = order.hmeliorder || {};
	const venyek = order.venyek || [];

	const handleBackClick = () => {
		if (order.hmeliorder?.hmeliorder_depot_prefix === "BETÉT") {
			navigate("/Meretvetel");
		} else {
			navigate("/Emeles");
		}
	};

	const displayValue = (value) => {
		if (value === null || value === undefined || value === "") return "-";
		if (Array.isArray(value)) return value.length ? value.join(", ") : "-";
		return value;
	};

	const renderValueWithUnit = (value, unit = null) => (
		<div className="d-flex align-items-center justify-content-end">
			<div className="px-3 py-2">{displayValue(value)}</div>
			{unit && (
				<div
					className="bg-light px-2 py-2 border-start text-muted"
					style={{ textAlign: "center", minWidth: "70px" }}
				>
					({unit})
				</div>
			)}
		</div>
	);

	const renderLeftRightRow = (label, leftValue, rightValue, unit = null) => (
		<tr key={label}>
			<td>{label}</td>
			<td className="text-end p-0">{renderValueWithUnit(leftValue, unit)}</td>
			<td className="text-end p-0">{renderValueWithUnit(rightValue, unit)}</td>
		</tr>
	);

	const groupComponentsBySide = (components = []) => {
		const grouped = {};

		components.forEach((comp) => {
			const key = comp?.aidfinance_national || "Ismeretlen tartozék";

			if (!grouped[key]) {
				grouped[key] = {
					name: key,
					left: "",
					right: "",
				};
			}

			if (comp.is_left === 1) {
				grouped[key].left = "Bal láb";
			} else {
				grouped[key].right = "Jobb láb";
			}
		});

		return Object.values(grouped);
	};

	return (
		<TablerLayout title="Rendelés összefoglaló táblázat">
			<div className="row justify-content-center">
				<div className="col-md-10 mb-4">
					<div className="card-body">
						<h5 className="mb-2 mt-3">Partner adatok</h5>
						<table className="table table-bordered table-striped align-middle elite-table mb-4">
							<tbody>
								<tr>
									<td>Név</td>
									<td>{displayValue(partner.partner_name)}</td>
								</tr>
								<tr>
									<td>TAJ</td>
									<td>{displayValue(partner.partner_taj)}</td>
								</tr>
								<tr>
									<td>Cím</td>
									<td>
										{partner.partner_zip || "-"} {partner.partner_city || "-"},{" "}
										{partner.partner_address || "-"}
									</td>
								</tr>
								<tr>
									<td>Telefon</td>
									<td>{displayValue(partner.partner_phone)}</td>
								</tr>
								<tr>
									<td>Email</td>
									<td>{displayValue(partner.partner_email)}</td>
								</tr>
								<tr>
									<td>Születési idő</td>
									<td>{displayValue(partner.partner_birthday)}</td>
								</tr>
								<tr>
									<td>Születési hely</td>
									<td>{displayValue(partner.partner_birthplace)}</td>
								</tr>
							</tbody>
						</table>

						<h5 className="mb-2 mt-4">Rendelés adatok</h5>
						<table className="table table-bordered table-striped align-middle elite-table mb-4">
							<tbody>
								<tr>
									<td>Méretlap szám</td>
									<td>{displayValue(hmeliorder.hmeliorder_specific_id)}</td>
								</tr>
								<tr>
									<td>Rendelés típusa</td>
									<td>
										{order.hmeliorder?.hmeliorder_order_type === 1
											? "Vényes"
											: order.hmeliorder?.hmeliorder_order_type === 2
											? "Telemedicina"
											: order.hmeliorder?.hmeliorder_order_type === 3
											? "Privát"
											: "-"}
									</td>
								</tr>
								<tr>
									<td>Projekt gyűjtőkód</td>
									<td>{displayValue(order.projekt?.hmgenproject_collection_code)}</td>
								</tr>
							</tbody>
						</table>

						{order.hmeliorder?.hmeliorder_order_type === 1 && (
							<>
								<h5 className="mb-2 mt-4">Vények</h5>
								{venyek.length === 0 ? (
									<div className="text-muted mb-4">Nincs vény.</div>
								) : (
									venyek.map((v, idx) => {
										const groupedComponents = groupComponentsBySide(v.components || []);

										return (
											<div className="mb-4 border rounded shadow-sm" key={idx}>
												<div className="d-flex align-items-center mb-2 p-2 bg-light border-bottom">
													<h6 className="mb-0 me-3">
														Vény #{idx + 1}
														{v.veny_receipt && (
															<span className="ms-2 fs-6 text-muted">
																({v.veny_receipt})
															</span>
														)}
													</h6>
												</div>

												<table className="table table-bordered table-striped align-middle mb-0">
													<tbody>
														<tr>
															<th style={{ width: "50%" }}>Felírás dátuma</th>
															<td>{displayValue(v.veny_inscript_date)}</td>
														</tr>
														<tr>
															<th>Lejárat</th>
															<td>{displayValue(v.veny_expirate_date)}</td>
														</tr>
														<tr>
															<th>Orvos</th>
															<td>{displayValue(v.veny_med_name)}</td>
														</tr>
														<tr>
															<th>BNO</th>
															<td>{displayValue(v.veny_bno_code)}</td>
														</tr>
														<tr>
															<th>Közgyógy ig. száma</th>
															<td>{displayValue(partner.partner_charitycare_num)}</td>
														</tr>
														<tr>
															<th>Egyedi kérelem száma</th>
															<td>{displayValue(v.veny_indvdl_permit_nr)}</td>
														</tr>
														<tr>
															<th>Üzemi baleset naplószám</th>
															<td>{displayValue(v.veny_indstrl_accdnt)}</td>
														</tr>
													</tbody>
												</table>

												<div className="border-top">
													<div className="p-3">
														<h6 className="mb-2 fw-bold">Tartozékok:</h6>

														{groupedComponents.length > 0 ? (
															<table className="table table-bordered table-striped align-middle mb-0">
																<thead>
																	<tr>
																		<th style={{ width: "50%" }}>Tartozék</th>
																		<th style={{ width: "25%" }} className="text-center">
																			Bal
																		</th>
																		<th style={{ width: "25%" }} className="text-center">
																			Jobb
																		</th>
																	</tr>
																</thead>
																<tbody>
																	{groupedComponents.map((comp, compIdx) => (
																		<tr key={compIdx}>
																			<td>{comp.name}</td>
																			<td className="text-center">
																				{comp.left || "-"}
																			</td>
																			<td className="text-center">
																				{comp.right || "-"}
																			</td>
																		</tr>
																	))}
																</tbody>
															</table>
														) : (
															<table className="table table-bordered align-middle mb-0">
																<tbody>
																	<tr>
																		<td className="text-muted">Nincs tartozék</td>
																	</tr>
																</tbody>
															</table>
														)}
													</div>
												</div>
											</div>
										);
									})
								)}
							</>
						)}

						<h5 className="mb-2 mt-4">Cipő adatok</h5>
						<table className="table table-bordered table-striped align-middle elite-table mb-4">
							<tbody>
								<tr>
									<td>Modell szám</td>
									<td>{displayValue(hmeliorder.hmeliorder_modell_num)}</td>
								</tr>
								<tr>
									<td>Cipő forma</td>
									<td>
										{hmeliorder.hmeliorder_is_hightopshoes === 1
											? "Magasszárú"
											: "Félcipő"}
									</td>
								</tr>
								<tr>
									<td>Rögzítés típusa</td>
									<td>
										{hmeliorder.hmeliorder_mounting_type === 2
											? "Fűző"
											: hmeliorder.hmeliorder_mounting_type === 3
											? "Csat"
											: hmeliorder.hmeliorder_mounting_type === 4
											? "Cúg"
											: hmeliorder.hmeliorder_mounting_type === 6
											? "Tépőzár"
											: "-"}
									</td>
								</tr>
								<tr>
									<td>Extra cipzár</td>
									<td>{hmeliorder.hmeliorder_exra_zipper ? "Igen" : "Nincs"}</td>
								</tr>
								<tr>
									<td>Speciális igények</td>
									<td>{displayValue(hmeliorder.hmeliorder_specialis_igeny)}</td>
								</tr>
								<tr>
									<td>Orr kivágás</td>
									<td>{hmeliorder.hmeliorder_spn_nose_cutout === 1 ? "Igen" : "Nincs"}</td>
								</tr>
								<tr>
									<td>Díszlyukasztás</td>
									<td>{hmeliorder.hmeliorder_spn_hole_punch === 1 ? "Igen" : "Nincs"}</td>
								</tr>
								<tr>
									<td>Díszöltés</td>
									<td>{hmeliorder.hmeliorder_spn_deco_stitch === 1 ? "Igen" : "Nincs"}</td>
								</tr>
								<tr>
									<td>Nyelv</td>
									<td>{hmeliorder.hmeliorder_spn_tongue === 1 ? "Igen" : "Nincs"}</td>
								</tr>
								<tr>
									<td>Orr forma</td>
									<td>
										{hmeliorder.hmeliorder_shoehornmodel_id === 2
											? "Formás vagy széles gömbölyű orr"
											: hmeliorder.hmeliorder_shoehornmodel_id === 3
											? "Vágott orr"
											: hmeliorder.hmeliorder_shoehornmodel_id === 4
											? "Neuropathiás / diab"
											: hmeliorder.hmeliorder_shoehornmodel_id === 5
											? "Sportos orr"
											: hmeliorder.hmeliorder_shoehornmodel_id === 6
											? "Kerek orr"
											: "-"}
									</td>
								</tr>
								<tr>
									<td>Sarok típusa</td>
									<td>{displayValue(hmeliorder.hmeliorder_corner_type)}</td>
								</tr>
								<tr>
									<td>Sarok mérete</td>
									<td>{displayValue(hmeliorder.hmeliorder_corner_height_szam)}</td>
								</tr>
								<tr>
									<td>Bélés típusa</td>
									<td>{displayValue(hmeliorder.hmeliorder_liner_material)}</td>
								</tr>
								<tr>
									<td>Orrverevítő típusa / anyaga</td>
									<td>{displayValue([hmeliorder.hmeliorder_nose_brace_type, hmeliorder.hmeliorder_nose_brace_mater].filter(Boolean).join(" / "))}</td>
								</tr>
							</tbody>
						</table>

						<table className="table table-bordered table-striped align-middle elite-table mb-4">
							<thead>
								<tr>
									<th style={{ width: "40%" }}>Cipő adatok</th>
									<th style={{ width: "30%" }} className="text-center">
										Bal
									</th>
									<th style={{ width: "30%" }} className="text-center">
										Jobb
									</th>
								</tr>
							</thead>
							<tbody>
								{renderLeftRightRow(
									"Kéreg",
									hmeliorder.hmeliorder_rind_material,
									hmeliorder.hmeliorder_rind_type
								)}
								{renderLeftRightRow(
									"Betét",
									hmeliorder.hmeliorder_insole_type_left,
									hmeliorder.hmeliorder_insole_type_right
								)}
								{renderLeftRightRow(
									"Donga",
									hmeliorder.hmeliorder_stave_left_value,
									hmeliorder.hmeliorder_stave_right_value,
									"mm"
								)}
								{renderLeftRightRow(
									"Donga megjegyzés",
									hmeliorder.hmeliorder_stave_left_remark,
									hmeliorder.hmeliorder_stave_right_remark
								)}
								{renderLeftRightRow(
									"Gördülő",
									hmeliorder.hmeliorder_rolling_left,
									hmeliorder.hmeliorder_rolling_right,
									"mm"
								)}
								{renderLeftRightRow(
									"Sarok emelés",
									hmeliorder.hmeliorder_cornerlift_left,
									hmeliorder.hmeliorder_cornerlift_right,
									"mm"
								)}
							</tbody>
						</table>

						<h5 className="mb-2 mt-4">Színek</h5>
						<div className="mb-4 border rounded shadow-sm">
							<div className="d-flex align-items-center mb-2 p-2 bg-light border-bottom">
								<h6 className="mb-0 me-3">Bőr színek</h6>
							</div>

							{(() => {
								const leatherColorRaw = order.hmeliorder?.hmeliorder_leather_color || "";
								const colorsAndMaterials = order.model_options?.colors_and_materials_for_model || {};

								const colorValues = leatherColorRaw
									.split(",")
									.map((item) => item.trim())
									.filter(Boolean);

								const groupKeys = Object.keys(colorsAndMaterials)
									.filter((key) => key.startsWith("color_group_"))
									.sort((a, b) => {
										const na = parseInt(a.replace("color_group_", ""), 10) || 0;
										const nb = parseInt(b.replace("color_group_", ""), 10) || 0;
										return na - nb;
									});

								if (colorValues.length <= 1) {
									return (
										<div className="p-3">
											<table className="table table-bordered table-striped align-middle mb-0">
												<tbody>
													<tr>
														<th style={{ width: "50%" }}>Bőr színe</th>
														<td>{colorValues[0] || "-"}</td>
													</tr>
												</tbody>
											</table>
										</div>
									);
								}

								return (
									<div className="p-3">
										<table className="table table-bordered table-striped align-middle mb-0">
											<thead>
												<tr>
													<th style={{ width: "50%" }}>Rész</th>
													<th>Szín</th>
												</tr>
											</thead>
											<tbody>
												{colorValues.map((color, index) => {
													const groupKey = groupKeys[index];
													const parts = Array.isArray(colorsAndMaterials[groupKey])
														? colorsAndMaterials[groupKey]
														: [];

													return (
														<tr key={`${groupKey || "group"}_${index}`}>
															<td>
																{parts.length ? parts.join(", ") : `Szín ${index + 1}`}
															</td>
															<td>{color || "-"}</td>
														</tr>
													);
												})}
											</tbody>
										</table>
									</div>
								);
							})()}
						</div>

						<table className="table table-bordered table-striped align-middle elite-table mb-4">
							<tbody>
								<tr>
									<td>Tűzés színe</td>
									<td>{displayValue(order.tuzes_szine_szin_name)}</td>
								</tr>
								<tr>
									<td>Ráma színe</td>
									<td>{displayValue(order.rama_szin_name)}</td>
								</tr>
								<tr>
									<td>Köztalp színe</td>
									<td>{displayValue(order.koztalp_szin_name)}</td>
								</tr>
								<tr>
									<td>Talp színe</td>
									<td>{displayValue(order.talp_szin_name)}</td>
								</tr>
							</tbody>
						</table>

						<h5 className="mb-2 mt-4">Láb adatok</h5>
						<table className="table table-bordered table-striped align-middle elite-table mb-4">
							<thead>
								<tr>
									<th style={{ width: "40%" }}>Megnevezés</th>
									<th style={{ width: "30%" }} className="text-center">
										Bal
									</th>
									<th style={{ width: "30%" }} className="text-center">
										Jobb
									</th>
								</tr>
							</thead>
							<tbody>
								{renderLeftRightRow(
									"Lábméret",
									hmeliorder.hmeliorder_footsize_left,
									hmeliorder.hmeliorder_footsize_right,
									"öltés"
								)}
								{renderLeftRightRow(
									"Bütyökbőség",
									hmeliorder.hmeliorder_butyokboseg_left,
									hmeliorder.hmeliorder_butyokboseg_right,
									"cm"
								)}
								{renderLeftRightRow(
									"Marbőség",
									hmeliorder.hmeliorder_marboseg_left,
									hmeliorder.hmeliorder_marboseg_right,
									"cm"
								)}
								{renderLeftRightRow(
									"Sarokbőség",
									hmeliorder.hmeliorder_sarokboseg_left,
									hmeliorder.hmeliorder_sarokboseg_right,
									"cm"
								)}
								{renderLeftRightRow(
									"Bokabőség",
									hmeliorder.hmeliorder_bokaboseg_left,
									hmeliorder.hmeliorder_bokaboseg_right,
									"cm"
								)}
								{renderLeftRightRow(
									"Szárbőség",
									hmeliorder.hmeliorder_szarboseg_left,
									hmeliorder.hmeliorder_szarboseg_right,
									"cm"
								)}
								{renderLeftRightRow(
									"Szármagasság",
									hmeliorder.hmeliorder_szarmagassag_left,
									hmeliorder.hmeliorder_szarmagassag_right,
									"cm"
								)}
								{renderLeftRightRow(
									"Ikrabőség",
									hmeliorder.hmeliorder_ikraboseg_left,
									hmeliorder.hmeliorder_ikraboseg_right,
									"cm"
								)}
							</tbody>
						</table>

						<h5 className="mb-2 mt-4">Emelések</h5>
						<table className="table table-bordered table-striped align-middle elite-table mb-4">
							<thead>
								<tr>
									<th style={{ width: "40%" }}>Megnevezés</th>
									<th style={{ width: "30%" }} className="text-center">
										Bal
									</th>
									<th style={{ width: "30%" }} className="text-center">
										Jobb
									</th>
								</tr>
							</thead>
							<tbody>
								{renderLeftRightRow(
									"Belső emelés orr",
									hmeliorder.hmeliorder_inraisnose_left,
									hmeliorder.hmeliorder_inraisnose_right,
									"mm"
								)}
								{renderLeftRightRow(
									"Belső emelés sarok",
									hmeliorder.hmeliorder_inraiscorner_left,
									hmeliorder.hmeliorder_inraiscorner_right,
									"mm"
								)}
								{renderLeftRightRow(
									"Belső emelés bütyök",
									hmeliorder.hmeliorder_inraisbutyok_left,
									hmeliorder.hmeliorder_inraisbutyok_right,
									"mm"
								)}
								{renderLeftRightRow(
									"Külső emelés orr",
									hmeliorder.hmeliorder_outraisnose_left,
									hmeliorder.hmeliorder_outraisnose_right,
									"mm"
								)}
								{renderLeftRightRow(
									"Külső emelés sarok",
									hmeliorder.hmeliorder_outraiscorner_left,
									hmeliorder.hmeliorder_outraiscorner_right,
									"mm"
								)}
								{renderLeftRightRow(
									"Külső emelés bütyök",
									hmeliorder.hmeliorder_outraisbutyok_left,
									hmeliorder.hmeliorder_outraisbutyok_right,
									"mm"
								)}
							</tbody>
						</table>

						<div className="col-12">
							<div className="card">
								<div className="card-header">
									<h5 className="card-title mb-0">Plusz megjegyzések</h5>
								</div>
								<div className="card-body">
									<div className="row">
										<div className="col-md-12">
											<table className="table table-borderless table-sm mb-0">
												<tbody>
													<tr>
														<td>{order.hmeliorder.hmeliorder_plus_note}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="mt-4 mb-3 d-flex justify-content-center">
							<button
								className={`btn ${
									isRead ? "btn-primary" : "btn-outline-primary"
								} btn-lg d-flex align-items-center gap-2 py-3 px-4`}
								onClick={() => setIsRead(!isRead)}
								style={{ fontSize: "1.1rem" }}
							>
								<div
									className="d-flex align-items-center"
									style={{ lineHeight: 1 }}
								>
									<div
										className="me-2 d-flex align-items-center justify-content-center"
										style={{ width: "24px", height: "24px", flexShrink: 0 }}
									>
										{isRead ? (
											<IconSquareCheck size={24} />
										) : (
											<IconSquare size={24} />
										)}
									</div>
									<span style={{ lineHeight: "24px" }}>
										Elolvastam és megértettem az összesítőt!
									</span>
								</div>
							</button>
						</div>
					</div>

					<div className="d-flex justify-content-between mt-4">
						<StepperNavButton side="left" label="Vissza" onClick={handleBackClick} />
						<StepperNavButton
							side="right"
							label="Tovább"
							onClick={async () => {
								try {
									if (!isRead) {
										alert(
											"Kérjük, először olvassa el és jelölje be, hogy megértette az összesítőt!"
										);
										return;
									}

									const orderWithPath = {
										...order,
										save_path_source: "FelolvasoTabla",
									};

									setLoading(true);

									try {
										const response = await dataService.getDivitems(orderWithPath);
										const data = response.data;

										if (data.status === "error") {
											setModal({
												open: true,
												message:
													"<h4>" +
														data.message +
														'</h4> <span style="color: grey">Kérem, próbálkozzon újra!</span>' ||
													"Hiba történt a divitemek lekérésekor! Kérem, próbálja újra!",
												type: "danger",
											});
											return;
										}

										const updatedOrder = {
											...order,
											divitems: data.data,
											divitem_selected:
												data.data.length === 1 ? data.data[0].divitem_szam : null,
										};

										updateOrder(updatedOrder);

										if (data.data && data.data.length > 1) {
											navigate("/Diviziok");
										} else {
											navigate("/Alairas");
										}
									} catch (error) {
										console.error(
											"Hiba történt a divitemek lekérése során:",
											error
										);
										setModal({
											open: true,
											message:
												"Hiba történt a divíziók lekérése során! Kérem, próbálja újra!",
											type: "danger",
										});
									} finally {
										setLoading(false);
									}
								} catch (error) {
									console.error("Hiba történt:", error);
									alert("Váratlan hiba történt. Kérjük, próbálja újra!");
								}
							}}
							disabled={!isRead || loading}
						/>
					</div>
				</div>
			</div>
		</TablerLayout>
	);
};

export default FelolvasoTabla;